module.exports = __webpack_public_path__ + "img/img_intro_1_deco1.d9fb5fd6.png";